<template>
    <modal :title="modalTitle" ref="modifyAdditionalPackageModal" @save="saveAdditionalPackage">
        <div class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Label</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="additionalPackage.label"
                />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Additional Billing Type</label>
                <v-select
                    :options="additionalBillingTypes"
                    placeholder="Select Type"
                    v-model="additionalPackage.additionalBilling"
                    >
                </v-select>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Price (Excl. VAT)</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="additionalPackage.priceExclVat"
                />
            </div>
        </div>
        <div class="row" v-if="additionalPackage.objKey">
            <div class="form-group col-md-12">
                <label class="control-label">Expired</label>
                <v-select
                    :options="['true', 'false']"
                    v-model="expired"
                    >
                </v-select>
            </div>
        </div>

    </modal>
</template>

<script>
import Modal from '@/components/GeneralComponents/Modal';

export default {
    components: {
        Modal
    },
    props: {
        modalTitle: {
            type: String,
            required: true,
        },
        additionalPackage: {
            type: Object,
            required: true,
        },
        additionalBillingTypes: {
            type: Array,
            required: true,
        }
    },
    computed: {
        expired: {
            get() {
                return this.additionalPackage.expired.toString();
            },
            set(expired) {
                this.additionalPackage.expired = expired;
            },
        },
    },
    methods: {
        open: function() {
            this.$refs.modifyAdditionalPackageModal.open();
        },
        saveAdditionalPackage: function() {
            if (this.additionalPackage.objKey !== 0) {
                this.$emit("updateAdditionalPackage", this.additionalPackage);
            } else {
                this.$emit("createAdditionalPackage", this.additionalPackage);
            }
        
            this.$refs.modifyAdditionalPackageModal.close();
        }
    }
    
}
</script>

<style scoped>

</style>